import React from "react";
import { Link } from "react-router-dom";
import '../styles/StudentCard.css';

import Deadline from "../deadline"
import checkIcon2 from "../images/check-icon2.svg";

export interface StudentCardProps2 {
    id: string;
    individualProgressId?: number;
    individualGoalId?: number;
    scholarshipProgressId?: number;
    scholarshipId?: number;
    title: string;
    firstName: string;
    lastName: string;
    studentStatusId: number;
    studentStatus: string;
    deadline: string;
    isCompleted: boolean;
    editCard: boolean;
    checkboxValue: any;
    index: number;
    link: string;
    onClick: any;
    handleOnCheckboxChange: any;
}

export default function StudentCard2({ id, individualProgressId, scholarshipProgressId, individualGoalId, scholarshipId, title, firstName, lastName, studentStatusId, studentStatus, deadline, isCompleted, editCard, checkboxValue, index, link, onClick, handleOnCheckboxChange }: StudentCardProps2) {

    const deadlineDate = new Deadline(new Date(deadline))

    const deadlineStyles = {
        color: (isCompleted || studentStatusId === 5) ? '' : deadlineDate.deadlineColor,
    }

    const borderStyles = {
        borderColor: (isCompleted || studentStatusId === 5) ? '' : deadlineDate.borderColor,
    }

    let cardClassName = "StudentCard-card"

    if (studentStatusId === 5) {
        cardClassName = "StudentCard-card dropout"
    } else if (isCompleted) {
        cardClassName = "StudentCard-card completed"
    }

    return (
        <>
            <div className={cardClassName} style={borderStyles}>
                {editCard &&
                    <input
                        type="checkbox"
                        id={`checkbox-${individualGoalId || scholarshipId}-${individualProgressId || scholarshipProgressId}`}
                        className="StudentCard-checkbox"
                        checked={checkboxValue}
                        onChange={() => handleOnCheckboxChange(index)}
                    />}
                <Link to={link} onClick={onClick} className="StudentCard-link">
                    <div className="StudentCard-name-wrapper">
                        <p className="StudentCard-name">{title} {firstName} {lastName}</p>
                        <div className="flex gap-dot5">
                            {studentStatusId === 5 &&
                                <span className="StudentCard-dropout-status">x พ้นสภาพฯ</span>
                            }
                            {isCompleted && <img src={checkIcon2} alt="" />}
                        </div>
                    </div>
                    <p className="StudentCard-studentID">{id}</p>
                    {
                        isCompleted ? (
                            <div className="StudentCard-deadline">
                                <p className="StudentCard-status">Completed</p>
                            </div>
                        ) : (
                            studentStatusId !== 5 &&
                            <div className="StudentCard-deadline" style={deadlineStyles}>
                                <h6 className="StudentCard-date">{deadlineDate.deadline}</h6>
                                <div className="flex gap-dot25">
                                    <img className="Goal-deadline-icon" src={deadlineDate.srcIcon} alt="" />
                                    <h6 className="StudentCard-countdown">{deadlineDate.diffDaysText}</h6>
                                </div>
                            </div>
                        )}
                </Link>
                {editCard && <label htmlFor={`checkbox-${individualGoalId || scholarshipId}-${individualProgressId || scholarshipProgressId}`} className="StudentCard-label"></label>}
            </div>

        </>
    )
}